<template>
  <div class="accordion-settings">
    <div class="card-header pointer" :id="`heading-${id}`" data-toggle="collapse" :data-target="`#cardBody-${id}`" aria-expanded="true" aria-controls="collapseOne">
      <h5 class="mb-0 ellipsis dropdown-arrow">
        {{ title }}
        <slot name="headerOptions"></slot>
      </h5>
    </div>
    <div :id="`cardBody-${id}`" class="collapse show" :aria-labelledby="`heading-${id}`" >
      <div class="card-body">

        <slot></slot>

      </div>
    </div>
  </div>

</template>

<script>
  export default {
    props: ['title'],
    name: "Collapse",
    data() {
      return {
        id:  Date.now() + parseInt(Math.random() * 10000)
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/base/sidebar/Abstract/Collapse.vue